import React from 'react'
import PropTypes from 'prop-types'
import SimpleReactCalendar from 'simple-react-calendar'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class SingleCalendar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    today: PropTypes.instanceOf(Date),
    onSelect: PropTypes.func
  }

  render() {
    const {className, minDate, maxDate, onSelect, today} = this.props
    const classNames = classnames('calendar-single', className)

    const calendarProps = {
      maxDate,
      minDate,
      onSelect,
      today
    }

    return (
      <div className={classNames}>
        <SimpleReactCalendar
          {...calendarProps}
          headerPrevArrow={<Icon className='calendar_icon-left' name='chevron' size='10px' />}
          headerNextArrow={<Icon className='calendar_icon-right' name='chevron' size='10px' />}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Calendar/SingleCalendar.js